import { Transition } from '@leafer-ui/draw'

import { TransitionList } from './Transition'

Object.assign(Transition.list, TransitionList)